<template>
  <div class="folder_choose_box" :key="forceUpdate">
    <div class="icon">
      <el-icon>
        <FolderOpened />
      </el-icon>
    </div>
    <div class="input_box">
      <template v-if="data.sendContent.length == 0">
        <div class="upload_box pointer" @dragover="dragover" @drop="drop">
          <div class="btn_box">
            <div class="folder_btn" @click="chooseFolder">
              <div class="icon marginAuto"><el-icon size="50px" color="#a8abb2">
                  <FolderOpened />
                </el-icon></div>
              <!-- <div class="title marginAuto">将【文件夹】拖到此处，或者<em>点击选择</em></div> -->
              <div class="title marginAuto"><em>点击选择文件夹</em></div>
            </div>
            <div class="file_btn" @click="choosefile">
              <div class="icon marginAuto"><el-icon size="50px" color="#a8abb2">
                  <Document />
                </el-icon></div>
              <!-- <div class="title marginAuto">将【文件夹】拖到此处，或者<em>点击选择</em></div> -->
              <div class="title marginAuto"><em>点击选择文件</em></div>
            </div>
          </div>
          <div class="desc marginAuto">会根据学员编码/学员姓名自动匹配跟发送学员相关的文件（同名请用学员编码命名）
            例如接收学员为李雷和韩梅梅，会在选中的文件夹中筛选出当前两位学员有关的文件，其他文件自动过滤掉</div>

          <input class='inp' type="file" ref="folder" multiple webkitdirectory @change="inputChange">
        </div>
      </template>
      <template v-else>
        <div class="table_list">
          <div class="matched_box" v-if="matchedStudents.length">
            <div class="til"><b>已匹配：</b></div>
            <div class="content"> 已经为学员 {{ resolveStudentsName(matchedStudents) }} <b>{{ matchedStudents.length }}</b> 人
              分别定制了专属文件
              <span v-if="matchedMoreThen2Students.length">,其中{{ resolveStudentsName(matchedMoreThen2Students) }} <b>{{
                matchedMoreThen2Students.length }}</b> 人 有多份专属文件</span>
            </div>
            <div class="tpa_text_btn_box">
              <span class="tpa_text_btn" @click="gotoPreview">去预览</span>
            </div>
          </div>
          <div class="unmatched_box" v-if='unmatchedStudents.length'>
            <div class="til"><b>未匹配：</b></div>
            <div class="content">学员{{ resolveStudentsName(unmatchedStudents) }} <b>{{ unmatchedStudents.length }}</b>
              人 还没有专属文件。</div>
            <div class="tpa_text_btn_box">
              <span class="tpa_text_btn" @click="showChooseDialog = true">去补充</span>
            </div>
          </div>
          <!-- <el-table stripe :data="tableData" style="width: 100%">
            <el-table-column prop="studentCode" label="学员编码" width="150" />
            <el-table-column prop="studentName" label="学员名称" width="100" />
            <el-table-column label="文件路径">
              <template #default="scope">
                <ul class="file_name_list folder_file_box">
                  <li class="list_item" v-for="(item, index) in scope.row.filePaths" :key='index'>
                    <fileCard :file-data="item"></fileCard>
                  </li>
                </ul>
              </template>
</el-table-column>
</el-table> -->
        </div>
      </template>
    </div>
    <el-dialog v-model="dialogVisible" title="定制文件匹配预览" width="80%" destroy-on-close :close-on-click-modal="false">
      <el-table stripe :data="tableData" height="60vh" table-layout="fixed" :border="true">
        <el-table-column class="no-break" prop="studentName" label="学员姓名" min-width="100px" />

        <el-table-column v-for="(item, index) in contentColumns" :label="item" min-width="220px">
          <template #default="scope">
            <!-- <span>{{ JSON.stringify(scope.row.sendContents[index].sendContent) }}</span> -->
            <div class="hover_show_box">{{ getFileName(scope.row.filePaths[index]?.path) }} <span
                class="hover_show_icon"> <el-icon @click="delFile(scope.$index, scope.row, index)">
                  <Delete />
                </el-icon></span></div>
          </template>
        </el-table-column>
        <el-table-column label="操作" fixed="right" align="right">
          <template #default="scope">
            <el-button size="small" type="danger" @click="handleDelete(scope.$index, scope.row)">
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
    <el-dialog v-model="showChooseDialog" title="补充定制文件" destroy-on-close :close-on-click-modal="false">
      <el-divider content-position="left">
        未匹配学员
      </el-divider>
      <el-scrollbar max-height="75px">
        <div class="student_box">

          <el-space wrap>
            <el-tag class="tag" v-for="tag in unmatchedStudents" :key="tag.studentCode" type="primary">
              {{ tag.studentName }}
            </el-tag>
          </el-space>
        </div>
      </el-scrollbar>
      <el-divider></el-divider>
      <div class="btn_box">
        <div class="folder_btn" @click="chooseFolder">
          <div class="icon marginAuto"><el-icon size="50px" color="#a8abb2">
              <FolderOpened />
            </el-icon></div>
          <!-- <div class="title marginAuto">将【文件夹】拖到此处，或者<em>点击选择</em></div> -->
          <div class="title marginAuto">点击选择文件夹</div>
        </div>
        <div class="file_btn" @click="choosefile">
          <div class="icon marginAuto"><el-icon size="50px" color="#a8abb2">
              <Document />
            </el-icon></div>
          <!-- <div class="title marginAuto">将【文件夹】拖到此处，或者<em>点击选择</em></div> -->
          <div class="title marginAuto">点击选择文件</div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script setup>
import { computed, onMounted, ref, watch } from 'vue';
import { pickFolder, pickFiles } from '@/utils/callingAppApi'
import { ElNotification, ElMessageBox } from 'element-plus';
import { getFileName } from '@/utils/util';
let chooseing = false;
const props = defineProps({
  data: {
    type: Object,
    required: true
  },
  sendTarget: {
    type: Array,
    required: true
  }
})
const dialogVisible = ref(false);
const showChooseDialog = ref(false);
const forceUpdate = ref(1);
watch(() => props.sendTarget, () => {
  // TODO: 删除？？？？？？ 要找到 新的中删除的人
  let delIndex = -1;
  // console.log("watch(props.senedTarget",props.sendTarget,props.data.sendContent)
  props.data.sendContent.forEach((item, index) => {
    if (props.sendTarget.every(t => t.studentCode != item.studentCode)) {
      delIndex = index;
    }
  })
  // console.log('delIndex',delIndex)
  if (delIndex > -1) {
    props.data.sendContent.splice(delIndex, 1)
  }
}, { deep: true })
const resolveStudentsName = (list) => {
  if (list.length > 3) {
    return `${list.slice(0, 3).map(item => item.studentName).join('、')}等`
  } else if (list.length > 0) {
    return `${list.map(item => item.studentName).join('、')}`
  }
  return '';
}
const matchedStudents = computed(() => {
  console.log(111, props.data.sendContent)
  return props.data.sendContent;
})
const matchedMoreThen2Students = computed(() => {
  return props.data.sendContent.filter(item => item.filePaths.length > 1);
})
const unmatchedStudents = computed(() => {
  return props.sendTarget.filter(item => {
    return !props.data.sendContent.some(item2 => item2.studentCode == item.studentCode)
  })
})
const tableData = computed(() => {
  return props.data.sendContent
})
const contentColumns = computed(() => {
  let maxContent = [];
  tableData.value.forEach(item => {
    if (item.filePaths.length > maxContent.length) {
      maxContent = item.filePaths.map((v, i) => '文件' + (i + 1))
    }
  })
  return maxContent
})

const folder = ref()

const chooseFolder = () => {
  showChooseDialog.value = false;
  if (chooseing) return;
  chooseing = true;
  // folder.value.click()
  pickFolder((paths = []) => {
    chooseing = false;
    if (paths.length == 0) return;
    // console.log("选择的文件家中的文件：", paths)
    let hasMateFile = false;
    props.sendTarget.forEach(student => {
      paths.forEach(path => {
        const fileName = getFileName(path)
        if (fileName.indexOf(student.studentCode) > -1 || fileName.indexOf(student.studentName) > -1) {
          // console.log(path, student.studentName, path.indexOf(student.studentName), path.indexOf(student.studentCode))
          hasMateFile = true;
          // 对应文件匹配到相应的人
          let isExist = props.data.sendContent.some(info => {
            if (info.studentCode == student.studentCode) {
              if (!info.filePaths.some(item => item.path == path)) {
                // 新文件
                info.filePaths.push({
                  path
                })
              }
              return true
            }
          })
          if (!isExist) {
            // console.log(3, path)
            props.data.sendContent.push({
              studentName: student.studentName,
              studentCode: student.studentCode,
              filePaths: [{ path }]
            })
          }

        }
      })
    })
    forceUpdate.value++;

    if (!hasMateFile) {
      ElNotification({
        title: '提醒',
        message: '该文件夹下没有与当前发送人匹配的文件',
        type: 'error',
      })
    }
  })
};
const choosefile = () => {
  showChooseDialog.value = false;
  if (chooseing) return;
  chooseing = true;
  // folder.value.click()
  pickFiles((paths = []) => {
    chooseing = false;
    if (paths.length == 0) return;
    // console.log("选择的文件家中的文件：", paths)
    let hasMateFile = false;
    props.sendTarget.forEach(student => {
      paths.forEach(path => {
        const fileName = getFileName(path)
        if (fileName.indexOf(student.studentCode) > -1 || fileName.indexOf(student.studentName) > -1) {
          // console.log(path, student.studentName, path.indexOf(student.studentName), path.indexOf(student.studentCode))
          hasMateFile = true;
          // 对应文件匹配到相应的人
          let isExist = props.data.sendContent.some(info => {
            if (info.studentCode == student.studentCode) {
              if (!info.filePaths.some(item => item.path == path)) {
                // 新文件
                info.filePaths.push({
                  path
                })
              }
              return true
            }
          })
          if (!isExist) {
            // console.log(3, path)
            props.data.sendContent.push({
              studentName: student.studentName,
              studentCode: student.studentCode,
              filePaths: [{ path }]
            })
          }

        }
      })
    })
    forceUpdate.value++;

    if (!hasMateFile) {
      ElNotification({
        title: '提醒',
        message: '该文件夹下没有与当前发送人匹配的文件',
        type: 'error',
      })
    }
  })
}
const handleDelete = (index, item) => {
  // console.log(item)
  // console.log(props.data.sendContent)
  ElMessageBox.confirm(
    '确认删除该学员所有定制文件吗？',
    '提醒',
    {
      confirmButtonText: '确认',
      cancelButtonText: '取消',
      type: 'warning',
    }
  )
    .then(() => {
      props.data.sendContent.splice(index, 1)
    })
    .catch(() => {

    })

}
const delFile = (studentIndex, item, fileIndex) => {
  item.filePaths.splice(fileIndex, 1)
  if (item.filePaths.length == 0) {
    props.data.sendContent.splice(studentIndex, 1)
  }
}
const gotoPreview = () => {
  dialogVisible.value = true;
}
const dragover = (e) => {
  e.preventDefault();
  e.stopPropagation()
};
const drop = (e) => {

};
const inputChange = (e) => {

}

</script>

<style lang="less" scoped>
.folder_choose_box {
  display: flex;
  align-items: center;

  .icon {
    width: 50px;
    text-align: center;
  }

  .input_box {
    flex: auto;
    width: 600px;
    border: 1px solid #ccc;
    padding: 10px;
    position: relative;

    .table_list {
      width: 580px;
    }

    .file_name_list {
      list-style: none;
      display: flex;
      flex-wrap: wrap;
      width: 100%;

      .list_item {
        margin: 5px 0;
        // width: 95%;
        font-size: 14px;
        padding: 5px 10px;
        // background: #fff;
        line-height: 40px;
        white-space: pre-wrap;
      }
    }

    .inp {
      position: absolute;
      width: 100%;
      height: 100%;
      opacity: 0;
      top: 0;
      left: 0;
      display: none;
    }
  }

}

.btn_box {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 20px;

  .folder_btn,
  .file_btn {
    width: 130px;
    text-align: center;
    cursor: pointer;
    color: var(--el-color-primary);
  }
}

:deep(.el-table__header) {
  width: 100% !important;
}

:deep(.el-table__body) {
  width: 100% !important;
}

:deep(.el-table--enable-row-transition .el-table__body td.el-table__cell) {
  height: auto !important;
}

.matched_box {
  margin-bottom: 10px;
  padding-bottom: 10px;
  border-bottom: 1px dashed #ccc;
}

.matched_box,
.unmatched_box {
  display: flex;
  justify-content: space-between;

  .til {
    width: 70px;
  }

  .content {
    width: 455px;
  }

  .tpa_text_btn_box {
    width: 55px;
  }
}

.hover_show_box {
  display: flex;
  align-items: center;
  justify-content: flex-start;

  .hover_show_icon {
    display: none;
    position: relative;
    top: 2px;
    margin-left: 5px;
  }

  &:hover {
    .hover_show_icon {
      display: block;
      cursor: pointer;

      &:hover {
        color: var(--el-color-primary);
      }
    }
  }
}
</style>